<template>
    <div>
        <div class="top">
            <div class="top-header">
            </div>
            <div class="container" v-if="orderInfo">
                <div class="header">
                    <h3>{{orderInfo.companyName}}</h3>
                    <p>{{orderInfo.companyBatchName}}</p>
                </div>

                <div class="card employee-wrapper">
                    <div class="emp-top">
                        <span class="emp-name">{{orderInfo.name}}</span><span
                            class="emp-mobile">{{orderInfo.mobile|mask("phone")}}</span>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">证件号码</div>
                        <div class="cell-value">{{orderInfo.idcard|mask("idcard")}}</div>
                    </div>
                    <div class="info-cell">
                        <div class="cell-text">体检编号</div>
                        <div class="cell-value">{{orderInfo.examNo}}</div>
                    </div>
                </div>

                <div class="card">
                    <p class="title">请选择套餐方案</p>
                    <div class="group-list">
                        <div v-for="group in companyGroups" class="group-wrap "
                            :class="group.selected?'group-wrap--selected':'group-wrap--noselect'">
                            <div class="group-info">
                                <div class="group-name">{{group.name}}</div>
                                <div class="group-details" @click="onShowGroupDetail(group)">
                                    共{{group.items.length}}项检查项目<i class=""></i></div>
                                <div class="group-desc">{{group.remark}}</div>
                            </div>
                            <div class="group-action" @click="onSelectGroup(group)">
                                <van-icon name="checked" color="#1496f1" v-if="group.selected" />
                                <van-icon name="circle" v-else />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fixed-footer page-footer">
            <div class="btn-wrap">
                <van-button type="info" size="large" :disabled="buttonDisable" @click="submit()">选好了</van-button>
                <!-- <div class="btn" @click="submit()">选好了</div> -->
            </div>
        </div>

        <!-- 显示分组明细项目 -->
        <van-popup v-model="showGroupItems" round position="bottom">
            <div class="group-items-wrapper">
                <p class="group-items-header">{{groupName}}</p>
                <div v-for="group in groupItems">
                    <div class="group-title">{{group.title}}</div>
                    <ul class="item-list">
                        <li v-for="(item,i) in group.items" class="item-detail">
                            <p class="item-name">{{item.itemName}}</p>
                            <p class="item-mean">{{item.itemMeanning}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<style lang="less" scoped>
    .top {
        width: 100%;
        position: relative;
        z-index: 0;
        overflow: hidden;
        color: #ffffff;
        margin-bottom: 80px;
    }

    .top::before {
        content: '';
        width: 120%;
        height: 160px;
        position: absolute;
        left: -10%; //椭圆左边隐藏10%，右边隐藏10%
        top: 0;
        border-radius: 0 0 50% 50%; //左上角，右上角，右下角，左下角
        background: #1496f1;
        z-index: -1;
    }

    .container {
        width: calc(100% - 20px);
        min-height: 80vh;
        top: 0;
        left: 0;
        padding: 10px;
        padding-bottom: 60px;

        .header {
            color: #ffffff;

            h3 {
                line-height: 36px;
                font-size: 20px;
                font-weight: 600;
            }

            p {
                font-size: 14px;
            }
        }

        .card {
            margin-top: 16px;
            background: #ffffff;
            border-radius: 8px;
            color: rgba(0, 0, 0, 0.75);
            padding: 16px;

            .title {
                font-size: 16px;
                font-weight: 600;
                margin-bottom: 10px;
                text-align: center;
            }
        }

        .employee-wrapper {
            .emp-top {
                margin-bottom: 10px;

                .emp-name {
                    font-size: 18px;

                }

                .emp-mobile {
                    margin-left: 16px;
                    font-size: 14px;
                    color: rgba(0, 0, 0, 0.45)
                }
            }


            .info-cell {
                display: flex;
                padding: 10px 0;
                font-size: 14px;

                .cell-text {
                    width: 100px;
                    color: rgba(0, 0, 0, 0.45);
                }

                .cell-value {
                    flex: 1;
                }
            }
        }

        .group-list {

            .group-wrap {
                border-radius: 8px;
                display: flex;
                padding: 10px;
                margin: 12px 0;

                .group-info {
                    flex: 1;

                    .group-name {
                        font-size: 16px;
                        font-weight: 600;
                    }

                    .group-details {
                        line-height: 28px;
                        font-size: 14px;
                        // color: #1496f1;
                    }

                    .group-desc {
                        font-size: 12px;
                        color: rgba(0, 0, 0, 0.45);
                    }
                }
            }

            .group-wrap--noselect {
                border: 2px solid #dddddd;
                box-shadow: 1px 1px 1px 0px #ececec;
            }

            .group-wrap--selected {
                border: 2px solid #1496f1;
                box-shadow: 1px 1px 2px 0px #bde4ff;
            }
        }

    }

    .time-range-wrapper {
        padding: 20px 12px;

        .timeRanges {
            // display: flex;
            // flex-wrap: nowrap;
            // justify-content: space-between;
            overflow-x: auto;
            padding: 12px 0;


            .time-item {
                flex: 1;
                font-size: 14px;
                padding: 8px 12px;
                border: 1px solid #fafafa;
                border-radius: 5px;
                // border: 1px solid #cccccc;
                background-color: #fafafa;
                margin: 16px 8px;
                text-align: center;

                p {
                    font-size: 12px;
                    margin-top: 6px;
                    font-weight: 400;
                }
            }

            .time-item--disabled {
                color: #b5b5b5;

                p {
                    color: #b5b5b5;
                }
            }

            .time-item--selected {
                border: 1px solid var(--color-main);
                color: #169bd5;
                background-color: #f2f8fa;

                p {
                    color: var(--color-main);
                }
            }
        }

        .timeRanges--empty {
            display: flex;
            align-items: center;
            justify-content: center;
            min-height: 250px;
            text-align: center;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.45);
        }

        .appoint-time {
            line-height: 32px;
            color: #169bd5;
            margin-bottom: 16px;
        }
    }

    .group-items-wrapper {
        height: 80vh;
        overflow: auto;
        padding: 0 16px;

        .group-items-header {
            text-align: center;
            padding-top: 12px;
        }

        .group-title {
            font-size: 16px;
            font-weight: 600;
            padding: 16px 0 10px 0;
        }

        .item-list {
            padding: 0 16px;

            .item-detail {
                padding: 8px 0;
                border-bottom: 1px solid rgba(0, 0, 0, 0.05);

                .item-name {
                    font-size: 14px;
                    padding-bottom: 4px;
                }

                .item-mean {
                    font-size: 12px;
                    color: rgba(0, 0, 0, 0.45);
                }
            }
        }
    }

    .page-footer {
        display: flex;

        .total-wrap {
            flex: 1;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.5);
            // font-weight: 300;
            padding: 6px 12px;

            .num-tag {
                font-size: 16px;
                font-weight: 600;
                color: #ff6633;
                margin-left: 8px;
            }
        }

        .btn-wrap {
            flex: 1;
            padding: 16px;

            .btn {
                width: 100%;
                height: 40px;
                border-radius: 8px;
                text-align: center;
                line-height: 40px;
                font-size: 14px;
                font-weight: 600;
                background: #1496f1;
                color: #fff;
                // border: 1px solid var(--color-main);
            }
        }
    }
</style>

<script>
    import {
        getGroups,
        getGroupDetails,
        getComboCategories
    } from '@/api/company';
    import {
        async
    } from 'q';
    import moment from 'moment';
    import Vue from 'vue';
    import {
        Sidebar,
        SidebarItem
    } from 'vant';

    Vue.use(Sidebar);
    Vue.use(SidebarItem);

    export default {
        name: "companyGroupSelect",
        data() {
            return {
                selectedIndex: -1,
                orderInfo: {},
                groupInfo: {},
                showGroupItems: false,
                groupName: '', //显示在弹出窗口的分组套餐名称
                groupItems: [],
                activeKey: 0,
                companyGroups: [],
            }
        },
        computed: {
            hospId: function () {
                return this.$route.query.hospid;
            },
            groupItemsCount: function () {
                if (this.orderInfo && this.orderInfo.groupItems && this.groupItems.length) {
                    return this.orderInfo.groupItems.length;
                } else {
                    return 0;
                }
            },
            buttonDisable: function () {
                if (!this.companyGroups || !this.companyGroups.length == 0) {
                    return false;
                }
                let idx = this.companyGroups.findIndex(it => {
                    return it.selected
                }) >= 0;
                return idx < 0;
            }
        },
        methods: {
            onSelectGroup(group) {
                this.companyGroups.forEach(g => g.selected = false);
                group.selected = true;
            },
            onShowGroupDetail(group) {
                this.groupItems = [];
                this.groupName = group.name;
                if (group.items && group.items.length > 0) {
                    var items0 = group.items.filter(it => {
                        return it.itemType == 0
                    });
                    if (items0.length > 0) {
                        this.groupItems.push({
                            title: "一般检查",
                            items: items0
                        })
                    }
                    var items1 = group.items.filter(it => {
                        return it.itemType == 1
                    });
                    if (items1.length > 0) {
                        this.groupItems.push({
                            title: "影像及辅助检查",
                            items: items1
                        })
                    }
                    var items2 = group.items.filter(it => {
                        return it.itemType == 2
                    });
                    if (items2.length > 0) {
                        this.groupItems.push({
                            title: "检验项目",
                            items: items2
                        })
                    }
                    var items3 = group.items.filter(it => {
                        return it.itemType == 3
                    });
                    if (items3.length > 0) {
                        this.groupItems.push({
                            title: "其它项目",
                            items: items3
                        })
                    }

                    this.showGroupItems = true;
                }
            },
            submit() {
                var selectedGroup = this.companyGroups.find(it => {
                    return it.selected
                });
                if (selectedGroup == null) {
                    this.$toast.fail('请选择一个套餐方案');
                    return;
                } else {
                    this.orderInfo.groupId = selectedGroup.id;
                    this.orderInfo.groupName = selectedGroup.name;
                    this.orderInfo.groupItems = selectedGroup.items;
                    localStorage.setItem('companyAppointment', JSON.stringify(this.orderInfo));
                    this.$router.replace({
                        path: "/company/orderDetail"
                    });
                }
            },
        },
        mounted() {
            let hospid = this.$route.query.hospid;
            var appt = JSON.parse(localStorage.getItem("companyAppointment"));
            if (appt == null) {
                this.$router.push('/');
                return;
            }
            this.orderInfo = appt;

            getGroups(appt.id).then(res => {
                if (res.data == null) {
                    this.$router.replace({
                        path: "/company/orderDetail"
                    });
                    return;
                } else {
                    res.data.forEach(g => g.selected = false);
                    this.companyGroups = res.data;
                }
            });
        }
    }
</script>